import { ReadMoreOnly, ReadMoreSpan } from "@/components/ModalReadMore";
import SwiperMC from "@/components/SwiperMC";
import { PAGE_URL } from "@/utils/constants";
import { convertTextContainingLink, shuffleArray } from "@/utils/helper";
import dayjs from "dayjs";
import Link from "next/link";
import { useEffect, useRef, useState } from "react";
import cx from "classnames";
import { isMobile } from "react-device-detect";

function AnnouncementRenderer({ content }: { content: string }) {
  const contentRef = useRef<HTMLDivElement>(null);
  const [isContentClamped, isContentClampedSet] = useState<boolean>(true);

  useEffect(() => {
    if (contentRef.current) {
      const { clientHeight, scrollHeight } = contentRef.current;
      isContentClampedSet(clientHeight < scrollHeight);
    }
  }, [contentRef.current]);
  return (
    <>
      <div
        ref={contentRef}
        className={cx(
          "max-w-lg text-white w-full mx-auto line-clamp-3",
          isMobile && "px-4",
        )}
        dangerouslySetInnerHTML={{
          __html: convertTextContainingLink(content),
        }}
      />
      {isContentClamped && (
        <ReadMoreOnly
          title="Broadcast Message"
          content={convertTextContainingLink(content)}
        />
      )}
    </>
  );
}

export default function MotivationalQuotes({
  data: userViewData,
}: {
  data: any;
}) {
  const [data, dataSet] = useState<
    {
      header: string;
      announcementTittle: string;
      title: string;
      author: string;
    }[]
  >([]);

  useEffect(() => {
    if (userViewData) {
      const mapped = userViewData?.announcements
        ? userViewData?.announcements?.map((x: any) => ({
            header: "Announcement",
            announcementTittle: x?.title,
            title: x?.message,
            author: x?.messageSource,
            updatedAt: x?.updatedAt,
          }))
        : [];

      const shuffleMotivationalQuotes = shuffleArray([
        {
          header: "Motivational Quotes",
          title: "“Nothing is impossible. The word itself says 'I'm possible!”",
          author: "Audrey Hepburn",
        },
        {
          header: "Motivational Quotes",
          title: "“Believe you can and you're halfway there.“",
          author: "Theodore Roosevelt",
        },
        {
          header: "Motivational Quotes",
          title:
            "“Success is not final, failure is not fatal: It is the courage to continue that counts.“",
          author: "Winston Churchill",
        },
        {
          header: "Motivational Quotes",
          title: "“The best way to predict the future is to create it.“",
          author: "Peter Drucker",
        },
      ]);

      dataSet((prev) => [...mapped, ...shuffleMotivationalQuotes]);
    } else {
      dataSet(
        shuffleArray([
          {
            header: "Motivational Quotes",
            title:
              "“Nothing is impossible. The word itself says 'I'm possible!”",
            author: "Audrey Hepburn",
          },
          {
            header: "Motivational Quotes",
            title: "“Believe you can and you're halfway there.“",
            author: "Theodore Roosevelt",
          },
          {
            header: "Motivational Quotes",
            title:
              "“Success is not final, failure is not fatal: It is the courage to continue that counts.“",
            author: "Winston Churchill",
          },
          {
            header: "Motivational Quotes",
            title: "“The best way to predict the future is to create it.“",
            author: "Peter Drucker",
          },
        ]),
      );
    }
  }, [userViewData]);

  return (
    <>
      <section className="bg-card p-6 w-full">
        <SwiperMC
          alwaysShowNavigation
          data={data}
          render={(payload, i) =>
            payload?.header === "Announcement" ? (
              <div
                key={i}
                className="flex flex-col items-center gap-1 text-center"
              >
                <p className="font-bold flex items-center gap-2">
                  {payload?.header}
                </p>
                <p className="text-lg">{payload?.announcementTittle}</p>
                <AnnouncementRenderer content={payload?.title} />
                <Link
                  shallow
                  href={{
                    pathname: PAGE_URL?.dashboard,
                    query: {
                      announcement: payload?.title,
                    },
                  }}
                  className="text-sm"
                >
                  <span className="text-yellow">{payload?.author}</span>
                </Link>
                <p className="text-[12px] text-grey">
                  {dayjs(payload?.updatedAt).format(
                    "MMMM DD, YYYY [at] hh:mm a",
                  )}
                </p>
              </div>
            ) : (
              <div
                key={i}
                className="flex flex-col items-center gap-2 text-center"
              >
                <p className="font-bold">{payload?.header}</p>
                <h3 className="text-[14px] font-bold">{payload?.title}</h3>
                <p className="text-sm">{payload?.author}</p>
              </div>
            )
          }
          props={{
            loop: true,
            wrapperClass: "items-center",
          }}
          showNavigationOnMobile
        />
      </section>
    </>
  );
}
